
import SearchHistoryContainer from "./SearchHistoryContainer";
import SearchHistoryStore from "./SearchHistoryStore";

export default SearchHistoryStore(SearchHistoryContainer); 
